<template>
  <section class="min-h-screen flex items-center justify-center pb-0 px-4 md:px-10 lg:px-20">
    <div class="container mx-auto flex flex-col lg:flex-row items-center justify-center lg:ml-40 lg:mr-40">
      <!-- Left Section (Text) -->
      <div class="text-center flex-1 flex flex-col items-center space-y-6 lg:pr-10" data-aos="fade-right">
        <h1 class="herotext text-5xl md:text-7xl lg:text-9xl hover-glow text-center">
          <span>R</span><span>E</span><span>V</span><span>E</span><span>S</span><span>T</span><span>3</span><span>6</span><span>0</span>
          <span>&nbsp;</span><span>I</span><span>N</span><span>C</span>
        </h1>

        <!-- Mobile Logo -->
        <div class="lg:hidden flex justify-center w-full">
          <div class="relative w-60 h-60 md:w-72 md:h-72">
            <img src="../assets/images/circle.svg" alt="Rotating Circle" class="absolute inset-0 w-full h-full animate-spin">
            <img src="../assets/images/logo.webp" alt="Revest360 company logo" class="absolute inset-0 rounded-full w-full h-full object-contain">
          </div>
        </div>

        <!-- Typing Animation -->
        <h2 class="typing-container text-4xl md:text-6xl lg:text-7xl font-semibold text-white text-center" data-aos="fade-up" data-aos-delay="200">
          <span class="typing">Circle of <span class="text-orange-400 font-bold">Prosperity</span></span>
          <span class="cursor">|</span>
        </h2>
      </div>

      <!-- Right Section (Desktop Logo) -->
      <div class="hidden lg:flex relative flex-1 justify-center lg:justify-end lg:pl-10" data-aos="fade-left" data-aos-delay="300">
        <div class="relative w-80 h-80 md:w-96 md:h-96 lg:w-[30rem] lg:h-[30rem]">
          <img src="../assets/images/circle.svg" alt="Rotating Circle" class="absolute inset-0 w-full h-full animate-spin">
          <img src="../assets/images/logo.webp" alt="Profile Image" class="absolute inset-0 rounded-full w-full h-full object-contain">
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useHead } from "@vueuse/head";
import { useAos } from '../hooks/useAos';

// SEO meta tags
useHead({
  title: "Revest360 Inc - Circle of Prosperity",
  meta: [
    { name: "description", content: "Revest360 Inc is dedicated to financial growth and success. Join our circle of prosperity." },
    { property: "og:title", content: "Revest360 Inc - Circle of Prosperity" },
    { property: "og:description", content: "Revest360 Inc is dedicated to financial growth and success. Join our circle of prosperity." },
    { property: "og:image", content: "/assets/images/logo.webp" },
    { property: "og:type", content: "website" },
  ],
});

useAos();
</script>

<style scoped>
/* Fix container responsiveness */
.container {
  max-width: 100%;
  padding: 0 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.animate-spin {
  animation: spin 4s linear infinite;
}

/* Typing Effect */
.typing-container {
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
}

.typing {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  width: 0;
  animation: typing 7s steps(40, end) infinite alternate;
}

.cursor {
  font-weight: bold;
  font-size: 1.2em;
  margin-left: 5px;
  animation: blink 0.8s infinite;
}

@keyframes typing {
  0% { width: 0; }
  50% { width: 100%; }
  100% { width: 0; }
}

@keyframes blink {
  50% { opacity: 0; }
}

@keyframes glowEffect {
  0%, 100% { text-shadow: none; color: white; }
  50% { text-shadow: 0 0 20px #ff9f45, 0 0 40px #ff9f45; color: #ff9f45; }
}

.hover-glow:hover span {
  animation: glowEffect 2s infinite ease-in-out;
}

/* Responsive Font Sizes */
@media (max-width: 1280px) {
  .herotext {
    font-size: 4rem;
    text-align: center;
  }
  .typing {
    font-size: 3rem;
  }
}

@media (max-width: 1024px) {
  .herotext {
    font-size: 3.5rem;
  }
  .typing {
    font-size: 2.5rem;
  }
}

@media (max-width: 768px) {
  .herotext {
    font-size: 3rem;
  }
  .typing {
    font-size: 2rem;
  }
}
</style>
